/**
 * Le due chiamate di rete che servono alla lingua, tenute fuori dal dizionario.
 *
 * `i18n.jsx` decide *quale* lingua mostrare; questo file fa le due cose che
 * richiedono un server: chiedere all'edge da quale paese arriva la richiesta
 * (ultimo suggerimento della lista) e salvare la scelta sull'account. Sono qui
 * e non nel provider perché il provider è montato in decine di test che
 * sostituiscono `@/lib/api` con due funzioni: importare il client axios
 * dentro il dizionario li farebbe esplodere per un motivo che non c'entra con
 * quello che stanno verificando.
 */
import http, { isAuthed } from "@/lib/api";

/**
 * La lingua suggerita dal paese dell'IP, o `null`.
 *
 * Il backend risponde `{country, locale, supported}` leggendo l'header che
 * l'edge ha già risolto: nessun indirizzo IP viene conservato, e se l'header
 * manca la risposta è `null` — meglio la lingua del browser che un paese
 * inventato.
 */
export const suggestLangFromEdge = async () => {
  try {
    const r = await http.get("/geo");
    return r.data?.supported ? r.data.locale : null;
  } catch {
    return null;
  }
};

/**
 * Salva la lingua dell'interfaccia sull'account, se c'è una sessione.
 *
 * Senza sessione non si chiama nulla: la preferenza locale (`hh_lang`) basta
 * per un visitatore, e un 401 a ogni cambio lingua nella barra sarebbe rumore
 * nei log per una cosa che funziona.
 */
export const saveLocaleToAccount = (locale) => {
  if (!isAuthed()) return Promise.resolve(null);
  return http.patch("/account/locale", { locale });
};
